import React from "react";
import { CreateFormTemplatePage } from "../../create-form-template/CreateFormTemplatePage";

export const EditFormTemplatePage = () => {
  return <CreateFormTemplatePage />;
};
